/* eslint-disable */
import i18n from '@/plugins/i18n';

export const statusLoans = [
  {
    text: i18n.t('app.loans.filter.form.status.open'),
    value: 'EM_ABERTO',
  },
  {
    text: i18n.t('app.loans.filter.form.status.closed'),
    value: 'PAGO',
  },
  {
    text: i18n.t('app.loans.filter.form.status.invalid'),
    value: 'INVALIDO',
  },
  {
    text: i18n.t('app.loans.filter.form.status.defeated'),
    value: 'VENCIDO',
  },
];